const videos = document.querySelectorAll(".carousel .video--hosted-video");

videos.forEach(videoWrap => {
  const video = videoWrap.querySelector("video");
  const icon  = videoWrap.querySelector(".video-icon");

  // helper to detect touch (phones & tablets)
  const isTouchDevice = () =>
    ('ontouchstart' in window) || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;

  // Play video when clicking play icon, pause others
  icon.addEventListener("click", e => {
    e.stopPropagation();
    e.preventDefault();
    videos.forEach(v => v.querySelector("video").pause());
    video.play();
  });

  // Pause on click only if NOT a touch device
  video.addEventListener("click", e => {
    if (!isTouchDevice()) {
      e.stopPropagation();
      e.preventDefault();
      if (!video.paused) video.pause();
    }
  });

  // UI state toggles
  video.addEventListener("play", () => {
    video.setAttribute("controls", "controls");
    video.closest(".video--hosted-video").classList.add("is-playing");
  });

  video.addEventListener("pause", () => {
    video.removeAttribute("controls");
    video.closest(".video--hosted-video").classList.remove("is-playing");
  });

  video.addEventListener("ended", () => {
    video.removeAttribute("controls");
    video.closest(".video--hosted-video").classList.remove("is-playing");
  });
});
